import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import animationData from '../balancebeam-loader.json';

// Rotating promotional messages
const loadingMessages = [
  "Taking control of your financial future...",
  "Your money, balanced and clear...",
  "Building your path to financial wellness...",
  "Making sense of your spending...",
  "Bringing clarity to your finances...",
  "Where smart money management begins...",
  "Transforming transactions into insights...",
  "Your financial story, beautifully organized...",
  "Empowering smarter spending decisions...",
  "Every shekel counts, tracked with precision...",
  "From chaos to clarity in seconds...",
  "Your money's best friend...",
  "Financial freedom starts here...",
  "See where your money goes, guide where it grows...",
  "Balance your budget, balance your life...",
  "Smart tracking for mindful spending...",
  "Your personal financial command center...",
  "Making money management effortless...",
  "Spend smart, save smarter...",
  "Know your numbers, own your future...",
];

/**
 * Unified Loader component with Lottie animation
 * @param {string} message - Optional loading message to display (defaults to random slogan)
 * @param {number} size - Size of the loader in pixels (default: 256)
 * @param {string} minHeight - Minimum height of the container (default: '300px')
 */
const Loader = ({ message, size = 256, minHeight = '300px' }) => {
  // Select a random message only once per component mount
  const displayMessage = useMemo(() => {
    if (message) return message;
    return loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
  }, [message]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: minHeight,
        py: 4,
        gap: 2,
      }}
    >
      <Box sx={{ width: size, height: size }}>
        <Lottie
          animationData={animationData}
          loop={true}
          autoplay={true}
          style={{ width: '100%', height: '100%' }}
        />
      </Box>
      {message && (
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            textAlign: 'center',
          }}
        >
          {displayMessage}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;
